import moment from "moment";
import { FC } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { RootState } from "../../store/rootReducer";
import { DateSelectType, DateTableType } from "../../constans";

export interface IProps {
  setStartDate: (date: string) => void;
  setEndDate: (date: string) => void;
  type?: DateTableType
  defSelType: number
  setDefSelType: (defSelType: number) => void;
  limitSameMonth?: boolean
  setSemesterCode?: (semesterCode: number | undefined) => void;
}

const StatDatePickerTable: FC<IProps> = ({
  setStartDate, setEndDate, type, defSelType, setDefSelType, limitSameMonth, setSemesterCode
}) => {
  const { t } = useTranslation();
  const { serverDate } = useSelector((state: RootState) => state.serverDate);

  const onSetDate = (period: DateSelectType) => {
    if (!serverDate) return;

    switch (period) {
      case DateSelectType.TDAY:
        setStartDate(moment(serverDate).format('YYYYMMDD'));
        setDefSelType(period);
        break;
      case DateSelectType.YDAY:
        if(limitSameMonth) {
          if(moment(serverDate).subtract(1, 'days').format('YYYYMM') === (moment(serverDate).format('YYYYMM'))) {
            setStartDate(moment(serverDate).subtract(1, 'days').format('YYYYMMDD'));
          } else {
            setStartDate(moment(serverDate).format('YYYYMM01'));
          }
        } else {
          setStartDate(moment(serverDate).subtract(1, 'days').format('YYYYMMDD'));
        }
        setDefSelType(period);
        break;
      case DateSelectType.DAYS3:
        if(limitSameMonth) {
          if(moment(serverDate).subtract(2, 'days').format('YYYYMM') === (moment(serverDate).format('YYYYMM'))) {
            setStartDate(moment(serverDate).subtract(2, 'days').format('YYYYMMDD'));
          } else {
            setStartDate(moment(serverDate).format('YYYYMM01'));
          }
        } else {
          setStartDate(moment(serverDate).subtract(2, 'days').format('YYYYMMDD'));
        }
        setDefSelType(period);
        break;
      case DateSelectType.DAYS7:
        if(limitSameMonth) {
          if(moment(serverDate).subtract(6, 'days').format('YYYYMM') === (moment(serverDate).format('YYYYMM'))) {
            setStartDate(moment(serverDate).subtract(6, 'days').format('YYYYMMDD'));
          } else {
            setStartDate(moment(serverDate).format('YYYYMM01'));
          }
        } else {
          setStartDate(moment(serverDate).subtract(6, 'days').format('YYYYMMDD'));
        }
        setDefSelType(period);
        break;
      case DateSelectType.MONTH1:
        if(limitSameMonth) {
          if(moment(serverDate).subtract(1, 'months').format('YYYYMM') === (moment(serverDate).format('YYYYMM'))) {
            setStartDate(moment(serverDate).subtract(1, 'months').format('YYYYMMDD'));
          } else {
            setStartDate(moment(serverDate).format('YYYYMM01'));
          }
        } else {
          setStartDate(moment(serverDate).subtract(1, 'months').format('YYYYMMDD'));
        }
        setDefSelType(period);
        break;
      case DateSelectType.MONTH3:
        setStartDate(moment(serverDate).subtract(3, 'months').format('YYYYMMDD'));
        setDefSelType(period);
        break;
      case DateSelectType.MONTH6:
        setStartDate(moment(serverDate).subtract(6, 'months').format('YYYYMMDD'));
        setDefSelType(period);
        break;
      case DateSelectType.YEAR1:
        setStartDate(moment(serverDate).subtract(1, 'years').format('YYYYMMDD'));
        setDefSelType(period);
        break;
    }

    if(setSemesterCode) {
      setSemesterCode(undefined);
    }

    setEndDate(moment(serverDate).format('YYYYMMDD'));
  }

  return (
    <>
      {(!type || type === DateTableType.SimpleYesterDay ) && 
      <button type="button" className={"btn-basic x-small gray-line " + ((defSelType === DateSelectType.YDAY)?'active':'')} onClick={() => onSetDate(DateSelectType.YDAY)}>{t('payment.record.column6')}</button>}
      <button type="button" className={"btn-basic x-small gray-line " + ((defSelType === DateSelectType.TDAY)?'active':'')} onClick={() => onSetDate(DateSelectType.TDAY)}>{t('payment.record.column5')}</button>
      {(!type) && <button type="button" className={"btn-basic x-small gray-line " + ((defSelType === DateSelectType.DAYS3)?'active':'')} onClick={() => onSetDate(DateSelectType.DAYS3)}>{t('payment.record.column7')}</button>}
      <button type="button" className={"btn-basic x-small gray-line " + ((defSelType === DateSelectType.DAYS7)?'active':'')} onClick={() => onSetDate(DateSelectType.DAYS7)}>{t('payment.record.column8')}</button>
      <button type="button" className={"btn-basic x-small gray-line " + ((defSelType === DateSelectType.MONTH1)?'active':'')} onClick={() => onSetDate(DateSelectType.MONTH1)}>{t('payment.record.column9')}</button>
      {(!type) && <button type="button" className={"btn-basic x-small gray-line " + ((defSelType === DateSelectType.MONTH3)?'active':'')} onClick={() => onSetDate(DateSelectType.MONTH3)}>{t('payment.record.column10')}</button>}
      {(!type) && <button type="button" className={"btn-basic x-small gray-line " + ((defSelType === DateSelectType.MONTH6)?'active':'')} onClick={() => onSetDate(DateSelectType.MONTH6)}>{t('payment.record.column11')}</button>}
      {(!type) && <button type="button" className={"btn-basic x-small gray-line " + ((defSelType === DateSelectType.YEAR1)?'active':'')} onClick={() => onSetDate(DateSelectType.YEAR1)}>{t('payment.record.column12')}</button>}
    </>
  );
}

export default StatDatePickerTable;
